// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-1fb69608]{box-sizing:border-box}.input-text[data-v-1fb69608]{box-sizing:border-box;display:inline-block;resize:none;padding:.25em;border-style:solid;border-width:1px;border-radius:2px;height:35px}.input-text.block[data-v-1fb69608]{display:block;width:100%}", ""]);
// Exports
module.exports = exports;
